import UserRoles from '@/store/core/user/user-roles'

export default {
  userApplications: [],
  locale: localStorage.getItem('locale') || 'en',
  selectedContentApp: null,
  selectedCdpApp: null,
  selectedAiWorkforceApp: null,
  selectedJobApp: null,
  selectedBusinessApp: null,
  socket: null,
  applications: [
    {
      id: 1,
      key: 'content',
      title: 'Contents'
    },
    {
      id: 2,
      key: 'project',
      title: 'Projects'
    },
    {
      id: 3,
      key: 'node',
      title: 'Node'
    },
    {
      id: 4,
      key: 'pipeline',
      title: 'Pipeline'
    },
    {
      id: 5,
      key: 'core',
      title: 'Core'
    },
    {
      id: 6,
      key: 'cdp',
      title: 'CDP'
    },
    {
      id: 7,
      key: 'synthetic_image',
      title: 'AI Generated Media'
    },
    {
      id: 8,
      key: 'home',
      title: 'Home'
    },
    {
      id: 9,
      key: 'ai_workforce',
      title: 'AI Workforce'
    },
    {
      id: 10,
      key: 'job',
      title: 'Jobs'
    },
    {
      id: 11,
      key: 'business',
      title: 'Business'
    }
  ],
  message: {
    open: false,
    type: null,
    text: null,
    timeout: process.env.VUE_APP_DEFAULT_SNACKBAR_TIMEOUT || 4000
  },
  menuItems: [
    {
      title: 'home',
      key: 'home',
      icon: 'mdi-home',
      icon_outline: 'mdi-home-outline',
      path: '^(\\/)$',
      href: '/?appId=:appId',
      reference_id: 8,
      children: []
    },
    {
      title: 'cdp',
      key: 'cdp',
      icon: 'mdi-cube',
      icon_outline: 'mdi-cube-outline',
      path: '/cdp',
      href: '/cdp/:appId/profile_view_export',
      reference_id: 6,
      children: []
    },
    {
      title: 'contents',
      key: 'content',
      icon: 'mdi-view-dashboard',
      icon_outline: 'mdi-view-dashboard-outline',
      path: '/content',
      href: '/content/:appId/navigation/home',
      reference_id: 1,
      children: []
    },
    {
      title: 'ai_workforce',
      key: 'ai_workforce',
      icon: 'mdi-robot',
      icon_outline: 'mdi-robot-outline',
      path: '/ai_workforce',
      href: '/ai_workforce',
      reference_id: 9,
      children: []
    },
    {
      title: 'jobs',
      key: 'job',
      icon: 'mdi-sticker-check',
      icon_outline: 'mdi-sticker-check-outline',
      path: '/job',
      href: '/job/:appId',
      reference_id: 10,
      children: []
    },
    {
      title: 'business',
      key: 'business',
      icon: 'mdi-briefcase',
      icon_outline: 'mdi-briefcase-outline',
      path: '/business',
      href: '/business/:appId/deliverables',
      reference_id: 11,
      children: []
    },
  ],
  coreSettingsItems: [
    {
      title: 'master_users',
      icon: 'mdi-account-box',
      url: '/settings/core/master_user',
      access_role: [
        UserRoles.USER_MASTER
      ]
    },
    {
      title: 'apps_instance',
      icon: 'mdi-content-duplicate',
      url: '/settings/core/application_instance',
      access_role: [
        UserRoles.USER_MASTER
      ]
    },
    {
      title: 'tenants',
      icon: 'mdi-home-account',
      url: '/settings/core/tenant',
      access_role: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN
      ]
    },
    {
      title: 'companies',
      icon: 'mdi-office-building',
      url: '/settings/core/company',
      access_role: [
        UserRoles.USER_ADMIN
      ]
    },
    {
      title: 'groups',
      icon: 'mdi-account-multiple',
      url: '/settings/core/group',
      access_role: [
        UserRoles.USER_ADMIN,
        UserRoles.USER_MANAGER
      ]
    },
    {
      title: 'users',
      icon: 'mdi-account',
      url: '/settings/core/user',
      access_role: [
        UserRoles.USER_ADMIN
      ]
    },
    {
      title: 'themes',
      icon: 'mdi-palette-outline',
      url: '/settings/core/theme',
      access_role: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN,
      ]
    },
  ],
  operationSettingsItems: [
    {
      title: 'actions',
      icon: 'mdi-play-box',
      url: '/settings/operation/action',
      access_role: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN,
      ]
    },
    {
      title: 'default_icons',
      icon: 'mdi-image-outline',
      url: '/settings/operation/defaulticon',
      access_role: [
        UserRoles.USER_MASTER
      ]
    },
    {
      title: 'actionsets',
      icon: 'mdi-play-box-multiple',
      url: '/settings/operation/actionset',
      access_role: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN,
      ]
    },
    {
      title: 'enablers',
      icon: 'mdi-leaf',
      url: '/settings/operation/enabler',
      access_role: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN,
      ]
    },
    {
      title: 'security',
      icon: 'mdi-security',
      url: '/settings/operation/security/group',
      access_role: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN,
      ]
    },
    {
      title: 'automations',
      icon: 'mdi-play-speed',
      url: '/settings/operation/automation',
      access_role: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN,
      ]
    },
    {
      title: 'filters',
      icon: 'mdi-filter',
      url: '/settings/operation/filter',
      access_role: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN,
      ]
    },
    {
      title: 'pipelines',
      icon: 'mdi-pipe',
      url: '/settings/operation/pipeline',
      access_role: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN,
      ]
    },
    {
      title: 'routines',
      icon: 'mdi-cog',
      url: '/settings/operation/routine',
      access_role: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN,
      ]
    },
    {
      title: 'servers',
      icon: 'mdi-server',
      url: '/settings/operation/server',
      access_role: [
        UserRoles.USER_MASTER,
        UserRoles.USER_ADMIN,
      ]
    }
  ],
  logsSettingsItems: [
    {
      title: 'operation',
      icon: 'mdi-text-box-search-outline',
      url: '/settings/logs/operation',
      access_role: [
        UserRoles.USER_ADMIN,
      ]
    }
  ],
  cdpSettingsItems: [
    {
      title: 'customer_properties',
      icon: 'mdi-card-account-details',
      routeName: 'CustomerProperty',
      access_role: [
        UserRoles.USER_ADMIN,
        UserRoles.USER_MANAGER,
        UserRoles.USER_REGULAR
      ]
    },
    {
      title: 'unomi_config',
      icon: 'mdi-circle-double',
      routeName: 'UnomiConfig',
      access_role: [
        UserRoles.USER_ADMIN
      ]
    },
    {
      title: 'unomi_console',
      icon: 'mdi-console',
      routeName: 'UnomiConsole',
      access_role: [
        UserRoles.USER_ADMIN,
      ]
    },
    {
      title: 'attribute_mapping',
      icon: 'mdi-file-tree',
      routeName: 'AttributeMapping',
      access_role: [
        UserRoles.USER_ADMIN,
        UserRoles.USER_MANAGER,
        UserRoles.USER_REGULAR
      ]
    },
    {
      title: 'profile_view',
      icon: 'mdi-clipboard-account',
      routeName: 'ProfileView',
      access_role: [
        UserRoles.USER_ADMIN,
        UserRoles.USER_MANAGER,
        UserRoles.USER_REGULAR
      ]
    },
  ],
  contentSettingsItems: [
    {
      title: 'file_servers',
      icon: 'mdi-server',
      routeName: "FileServer",
      access_role: [
        UserRoles.USER_ADMIN,
      ]
    },
    {
      title: 'repositories',
      icon: 'mdi-database',
      routeName: "Repository",
      access_role: [
        UserRoles.USER_ADMIN,
      ]
    },
  ],
  jobSettingsItems: [
    {
      title: 'pools',
      icon: 'mdi-view-sequential',
      routeName: "JobPools",
      access_role: [
        UserRoles.USER_ADMIN,
      ]
    },
    {
      title: 'statuses',
      icon: 'mdi-flag-variant',
      routeName: "JobStatuses",
      access_role: [
        UserRoles.USER_ADMIN,
      ]
    },
    {
      title: 'job_definitions',
      icon: 'mdi-clipboard-edit-outline',
      routeName: "JobDefinitions",
      access_role: [
        UserRoles.USER_ADMIN,
      ]
    },
    {
      title: 'user_acls',
      icon: 'mdi-shield-account',
      routeName: "JobUserAclSettings",
      access_role: [
        UserRoles.USER_ADMIN,
      ]
    },
    {
      title: 'configuration_map',
      icon: 'mdi-sitemap-outline',
      routeName: "JobConfigurationMap",
      access_role: [
        UserRoles.USER_ADMIN,
      ]
    },
  ],
  deliverableSettingsItems: [
    {
      title: 'customers',
      icon: 'mdi-account-group',
      routeName: 'BusinessCustomers',
      access_role: [
        UserRoles.USER_ADMIN,
        UserRoles.USER_MASTER,
      ]
    },
    {
      title: 'ratecards',
      icon: 'mdi-card-text-outline',
      routeName: 'BusinessRatecard',
      access_role: [
        UserRoles.USER_ADMIN,
        UserRoles.USER_MASTER,
      ]
    },
  ],
  contentPersonalPreferences: {
    navigationViewMode: localStorage.getItem('navigationViewMode') || 'grid',
  },
}
